import { GlobalName } from "./global-name";
import { LocalStorageService } from "./local-stoarge-service";

export const AppActionCheck: any = {
    

    check(feature:any, action:any) {
         let localService=new LocalStorageService();
         let user=localService.get(GlobalName.userName)
         if (user.roles[0].name=="Super Admin") {
            return true;
         }
         let permissions=user.roles[0]?.permissions;
         let check=permissions.find((el:any)=> el.name == `${action} ${feature}`)
         return check==undefined || check ==null?false:true
      }
}